export default __webpack_public_path__ + "static/media/granville11.feb2d908.jpg";